import React from 'react';
import { connect } from 'react-redux';
import {
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip
} from 'recharts';
import styled from "styled-components";

const formName = 'auctionSummaryReportSalesRepFilter';

const STATES = {
  sold: { name: 'SOLD', fill: '#49A949'},
  not_sold: { name: 'NOT SOLD', fill: '#E2750F'},
  pulled: { name: 'PULLED', fill: '#F0DC28'},
};

const RADIAN = Math.PI / 180;

const LegendStyle = styled('div')`
  && {
    height: 300px;
    width: 100%;
  }
  .recharts-legend-item {
    margin: 20px;
  }
`;

const SalesRepPieChart = ({data, filterValues}) => {
  let filteredData = data;
  if (filterValues.sales_reps.length) {
    filteredData = data.filter(datum => filterValues.sales_reps.includes(datum.name));
  }
  if (filteredData.length !== 1) return null

  let pieData = [
    { name: 'sold', value: filteredData[0].sold },
    { name: 'not_sold', value: filteredData[0].not_sold },
    { name: 'pulled', value: filteredData[0].pulled },
  ];
  if (filterValues.sales_states.length) {
    pieData = pieData.filter(datum => filterValues.sales_states.includes(datum.name));
  }

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {value}
      </text>
    );
  };

  return (
    <LegendStyle>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={400} height={400}>
          <Legend
            verticalAlign="middle"
            align="right"
            iconType="circle"
            layout="vertical"
            wrapperStyle={{fontSize: '12px', fontWeight: 500, paddingBottom: "25px"}}
          />
          <Tooltip />
          <Pie
            dataKey="value"
            data={pieData}
            cx="50%"
            cy="50%"
            outerRadius={120}
            fill="#8884d8"
            labelLine={false}
            label={renderCustomizedLabel}
            isAnimationActive={false}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={STATES[entry.name].fill} name={STATES[entry.name].name} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </LegendStyle>
  );
}

const mapStateToProps = state => ({
  filterValues: (state.form[formName] && state.form[formName].values) ? state.form[formName].values : {},
});

export default connect(mapStateToProps, null)(SalesRepPieChart);
